import { TextField } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { change } from '../../../store/actions/account.action'

const Avexpay = (props) => {
    const dispatch = useDispatch();
    const { account, error } = useSelector(state => state.accountReducer)

    return (
        <>
            <div className="mb-3">
                <label className="label-custom bs-color-b">Public Key</label>
                <TextField
                    error={(error.avexpay_public_key) && true}
                    value={account.avexpay_public_key || ''}
                    onChange={e => {
                        dispatch(change({avexpay_public_key: e.target.value}))
                        if (error.avexpay_public_key && delete error.avexpay_public_key);
                    }}
                />

                {(error.avexpay_public_key) &&
                    <strong className="text-danger">{error.avexpay_public_key[0]}</strong>
                }
            </div>

            <div className="mb-3">
                <label className="label-custom bs-color-b">Secret Key</label>
                <TextField
                    disabled={(props.id)}
                    error={(error.avexpay_secret_key) && true}
                    value={account.avexpay_secret_key || ''}
                    onChange={e => {
                        dispatch(change({avexpay_secret_key: e.target.value}))
                        if (error.avexpay_secret_key && delete error.avexpay_secret_key);
                    }}
                />

                {(error.avexpay_secret_key) &&
                    <strong className="text-danger">{error.avexpay_secret_key[0]}</strong>
                }
            </div>
        </>
    )
}


export default Avexpay